import store from 'state/store'

export default class ClanUnitsChannel {
    constructor(url) {
        this.ws = new WebSocket(url)
        this.ws.onmessage = this.onMessage.bind(this)
    }
    disconnect() {
        this.ws.close()
    }
    onMessage({ data }) {
        const { payload, type } = JSON.parse(data)
        if (!payload || !type) {
            // eslint-disable-next-line no-console
            console.error('Invalid action from clan units channel', data)
            return
        }

        store.dispatch({
            type,
            payload,
        })
    }
}


// WEBPACK FOOTER //
// ./channels/clan_units.js